module.exports = __webpack_public_path__ + "img/tutorial-05.52fbc08e.svg";